<template>
  <router-link :to="{ name: 'Vorlagen' }" class="btn btn-outline-secondary"><font-awesome-icon icon="chevron-left" /> Zurück</router-link>

  <div v-if="!loading && vorlage == null" class="alert alert-danger mt-5">Ungültige Vorlage ID: {{ vorlageid }}</div>

  <div v-else-if="!loading">
    <!-- TITEL -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1>{{ vorlage.name }}</h1>

      <router-link v-if="store.getters.isAdmin" :to="{ name: 'EditVorlage', query: { vorlageid: vorlageid } }" class="btn"
        ><font-awesome-icon icon="pen"
      /></router-link>
    </div>

    <!-- BESCHREIBUNG -->
    <div class="w-50 mb-2">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Vertrag Titel:</div>
        <div class="col">{{ vorlage.titel }}</div>
      </div>
    </div>

    <div class="w-50 mb-2">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Vertrag Titel EN:</div>
        <div class="col">{{ vorlage.titelEN }}</div>
      </div>
    </div>

    <div class="w-50 mb-2">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Gruppe:</div>
        <div class="col">
          <span v-for="gruppe in gruppen" :key="gruppe" class="badge text-bg-primary me-1 mb-1">{{ gruppe }}</span>
        </div>
      </div>
    </div>

    <div class="w-50 mb-2">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Typ:</div>
        <div class="col">{{ vorlage.type == 0 ? 'Neuvertrag' : 'Nachtrag' }}</div>
      </div>
    </div>

    <div class="w-50 mb-2">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Dokument ID:</div>
        <div class="col">{{ vorlage.docId }}</div>
      </div>
    </div>

    <div class="w-50 mb-4">
      <div class="row mb-2">
        <div class="col-3 fw-bold">Action ID:</div>
        <div class="col">{{ vorlage.actionId }}</div>
      </div>
    </div>

    <!-- TEXTBAUSTEINE -->
    <p><strong>Abschnitte</strong></p>
    <!-- <pre>{{ vorlage?.vorlageTextbausteine }}</pre> -->
    <div v-if="vorlage?.vorlageTextbausteine.length > 0" class="mt-3">
      <div class="row mx-0 mb-1">
        <div class="col-4 fw-bold px-2 my-auto">Baustein</div>
        <div class="col-3 fw-bold px-2 my-auto">Überschrift</div>
        <div class="col-2 fw-bold px-2 my-auto">Gruppe</div>
        <div class="col-1 fw-bold px-2 my-auto">Status</div>
        <div class="col-2 fw-bold px-2 my-auto">Abschnitte</div>
      </div>

      <TextbausteinRow
        v-for="vorlageTextbaustein in vorlage.vorlageTextbausteine.sort((a: VorlageTextbaustein, b: VorlageTextbaustein) => a.position - b.position)"
        :key="vorlageTextbaustein.id"
        :textbaustein="vorlageTextbaustein.textbaustein"
        :vorlageTextbaustein="vorlageTextbaustein"
        :showEdit="false"
      />
      <!-- class="mx-1 mb-2 p-2 bg-white shadow" -->
    </div>
  </div>

  <LoadingOverlay v-if="loading" text="... Daten werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, PropType, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';

  import TextbausteinRow from '@/components/Vorlagen/TextbausteinRow.vue';
  import LoadingOverlay from '@/components/LoadingOverlay.vue';

  import { Vorlage, VorlageTextbaustein } from '@/models/VorlageModels';
  //#endregion
  const props = defineProps({
    vorlageid: {
      type: String as PropType<string>,
      required: true,
    },
  });

  const store = useStore();

  const loading = computed(
    () => store.getters.status.getVorlageLoading || store.getters.status.createVorlageLoading || store.getters.status.deleteVorlageLoading
  );

  const vorlage = computed(() => store.getters.vorlagen.find((v: Vorlage) => v.id == parseInt(props.vorlageid)));

  const gruppen = computed(() => {
    const uniqueGruppen = new Array<string>();

    const gruppen = vorlage.value.gruppe.split(';');

    gruppen.forEach((gruppe: string) => {
      const trimmedGruppe = gruppe.trim();
      if (trimmedGruppe !== '' && !uniqueGruppen.includes(trimmedGruppe)) {
        uniqueGruppen.push(trimmedGruppe);
      }
    });

    return uniqueGruppen.sort();
  });

  onMounted(async () => {
    if (props.vorlageid != '' && props.vorlageid != '0') {
      await store.dispatch(VorlageActionTypes.GetVorlageById, parseInt(props.vorlageid));
    }
  });
</script>
